import React, { useState } from 'react';
import { Box, Typography, Container, TextField, Button } from '@mui/material';

interface QuoteProps {
  sectionRef: React.RefObject<HTMLDivElement | null>;
}

const Quote: React.FC<QuoteProps> = ({ sectionRef }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    description: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  return (
    <Box
      ref={sectionRef}
      sx={{
        minHeight: '100vh',
        position: 'relative',
        zIndex: 2,
        background: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(10px)',
        py: 8,
        mt: 4,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            color: '#000050',
            textAlign: 'center',
            mb: 6,
            fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
          }}
        >
          Get In Touch
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr' },
            gap: 4,
            maxWidth: '800px',
            mx: 'auto',
          }}
        >
          {[
            {
              title: 'Get Quote',
              description: 'Comprehensive enterprise-grade software solutions tailored to your business needs.',
            }
          ].map((feature, index) => (
            <Box
              key={index}
              sx={{
                p: 6,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0,0,80,0.2)',
                transition: 'all 0.3s ease'
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: '#000050',
                  mb: 2,
                  fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
                  fontWeight: 500,
                }}
              >
                {feature.title}
              </Typography>
              <Typography
                sx={{
                  color: '#000050',
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  lineHeight: 1.6,
                  mb: 4,
                }}
              >
                {feature.description}
              </Typography>

              <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  multiline
                  rows={4}
                  value={formData.description}
                  onChange={handleChange}
                  required
                  sx={{ mb: 3 }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: '#000050',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#000080',
                    },
                    py: 1.5,
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Quote; 